import React from 'react';
import { ArrowRightLeft } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { SidebarLink } from '@/components/ui/sidebar-animated';

interface DashboardToggleProps {
  open: boolean;
  className?: string;
}

const DashboardToggle: React.FC<DashboardToggleProps> = ({
  open,
  className,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine current dashboard type from URL
  const isFilmmakerDashboard = location.pathname.startsWith('/filmmaker');
  const isClientDashboard = location.pathname.startsWith('/client');

  const switchDashboard = () => {
    if (isFilmmakerDashboard) {
      navigate('/client/dashboard/hiring');
    } else if (isClientDashboard) {
      navigate('/filmmaker/dashboard/opportunities');
    }
  };

  // Determine button text based on current dashboard
  const getButtonText = () => {
    if (isFilmmakerDashboard) {
      return 'Switch to Client';
    } else {
      return 'Switch to Filmmaker';
    }
  };

  return (
    <div onClick={switchDashboard} className="cursor-pointer">
      <SidebarLink
        link={{
          label: <span className="text-primary">{getButtonText()}</span>,
          href: '#',
          icon: (
            <motion.div 
              className={cn(
                'flex items-center justify-center h-10 w-10',
                !open ? 'hover:bg-primary/10 dark:hover:bg-primary/20 rounded-md' : ''
              )}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 20 }}
            >
              <ArrowRightLeft className="text-primary dark:text-primary h-5 w-5 flex-shrink-0" />
            </motion.div>
          ),
        }}
        className={cn(
          "px-2 hover:bg-primary/5 dark:hover:bg-primary/10 rounded-md",
          className
        )}
      />
    </div>
  );
};

export default DashboardToggle;